import { useEffect, useReducer, useState } from "react";
import {
  initialslowmovingproducts,
  slowmovingproductsreducer,
} from "./initialstate_and_reducer";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "../../../context/LodingContext";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialButton from "../../../components/MaterialButton";
import MaterialInput from "../../../components/MaterialInput";
import { apicall } from "../../../Integration/apicall";
import {
  createslowmovingproducts,
  updateslowmovingproducts,
} from "./api/mutation";
import Swal from "sweetalert2";
import MaterialSelect from "../../../components/MasterSelect";
import request from "graphql-request";
import {
  getAllCustomerList,

  getAllCustomermasterDropdown,
  getslowproductsbyid,
} from "./api/query";
import BASEURL from "../../../pages/Utils/Baseurl";

const SlowmovingProductsForm = () => {
  const [currentslowmovingproducts, dispatch] = useReducer(
    slowmovingproductsreducer,
    initialslowmovingproducts
  );

  const slowMovingOptions = [
    { value: "Customer", label: "Customer" },
    { value: "Self", label: "Self" },
  ];

  const [customerList, setCustomerList] = useState([]);
  const [inputDisble, setInputDisble] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const { type, data } = location.state || {};
  const { userId } = useAuthData();

  // change type Add or edit or View using inputdisble or enable
  useEffect(() => {
    if (type === "view") {
      setInputDisble(true);
      Setslowmovingproducts(data);
      console.log(type, "type");
    } else {
      if (type == "edit") {
        Setslowmovingproducts(data);
      }
      setInputDisble(false);
    }
  }, [type]);

  const Setslowmovingproducts = (products) => {
    Object.entries(products).forEach(([key, value]) => {
      if (key == "slowMovingFor" || key == "customer") {
        console.log("aswqe");

        if (key == "customer") {
          console.log(value, "cusq323");
          value = { label: value?.customerName, value: value?.id };
        } else {
          value = { label: value, value };
        }
      }
      dispatch({ name: key, value });
    });
  };

  const handleSubmit = async () => {
    console.log("hgft");

    const edit = type == "edit" ? true : false;
    const filteredFields = Object.fromEntries(
      Object.entries(currentslowmovingproducts).filter(
        ([key]) => !key.endsWith("Status")
      )
    );
    console.log(filteredFields, "filteredFields");

    const variables = edit
      ? {
          input: {
            ...filteredFields,
            id: data?.id,
            slowMovingFor: currentslowmovingproducts?.slowMovingFor?.value,
            customer: currentslowmovingproducts?.customer?.value || null,
          },
        }
      : {
          input: {
            ...filteredFields,
            user: userId,
            slowMovingFor: currentslowmovingproducts?.slowMovingFor?.value,
            customer: currentslowmovingproducts?.customer?.value || null,
          },
        };

    const res = await apicall(
      edit ? updateslowmovingproducts : createslowmovingproducts,
      variables
    );
    console.log(res, "res");

    if (res.success) {
      const success = edit
        ? res.data.data.updateSlowMovingProduct.success
        : res.data.data.createSlowMovingProduct.success;
      const message = edit
        ? res.data.data.updateSlowMovingProduct.message
        : res.data.data.createSlowMovingProduct.message;
      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/slow-moving-products", {
            state:
              currentslowmovingproducts?.slowMovingFor?.value === "Customer"
                ? 2
                : 1,
          });
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } else {
    }
  };

  useEffect(() => {
    fetchCustomerList();
  }, []);

  const fetchCustomerList = async () => {
    try {
      const res = await request(BASEURL, getAllCustomermasterDropdown);
      const resData = res?.getAllCustomermasterDropdown;
      const customerData = resData?.data?.map((item) => ({
        value: item.id,
        label: item.customerName,
      }));
      setCustomerList(customerData);
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {type == "add" ? "Add " : type == "edit" ? "Edit " : "View "}
                   Slow Moving Products
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={currentslowmovingproducts?.productCode}
                  name="productCode"
                  placeholder="Enter Product Code"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productCode" })
                  }
                  error={
                    currentslowmovingproducts.productCodeStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    currentslowmovingproducts.productCodeStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={currentslowmovingproducts?.productName}
                  name="productName"
                  placeholder="Enter Product Name"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "productName" })
                  }
                  error={
                    currentslowmovingproducts.productNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    currentslowmovingproducts.productNameStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Brand <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={currentslowmovingproducts?.brand}
                  name="productBrand"
                  placeholder="Enter Product Brand"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "brand" })
                  }
                  error={
                    currentslowmovingproducts.brandStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    currentslowmovingproducts.brandStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Product Category <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={currentslowmovingproducts?.productCategory}
                  name="productCategory"
                  placeholder="Enter Product Category"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "productCategory",
                    })
                  }
                  error={
                    currentslowmovingproducts.productCategoryStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    currentslowmovingproducts.productCategoryStatus ===
                    "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Slow Moving For<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="slowMovingFor"
                  value={currentslowmovingproducts?.slowMovingFor}
                  placeholder="Enter Slow Moving For"
                  options={slowMovingOptions}
                  isDisabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      name: "slowMovingFor",
                      value: e,
                    })
                  }
                  error={
                    currentslowmovingproducts?.slowMovingForStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    currentslowmovingproducts?.slowMovingForStatus === "success"
                      ? true
                      : false
                  }
                ></MaterialSelect>
              </Grid>

              {currentslowmovingproducts?.slowMovingFor?.value ===
                "Customer" && (
                <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                  <MaterialSelect
                    name="customer"
                    value={currentslowmovingproducts?.customer}
                    options={customerList}
                    placeholder="Enter Select Customer"
                    isDisabled={inputDisble}
                    onChange={(e) => dispatch({ name: "customer", value: e })}
                    error={
                      currentslowmovingproducts?.customerStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      currentslowmovingproducts?.customerStatus === "success"
                        ? true
                        : false
                    }
                  ></MaterialSelect>
                </Grid>
              )}

              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Age of Stock <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  type="number"
                  value={currentslowmovingproducts?.ageOfStock}
                  name="ageOfStock"
                  placeholder="Enter ageOfStock"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "ageOfStock",
                    })
                  }
                  error={
                    currentslowmovingproducts.ageOfStockStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    currentslowmovingproducts.ageOfStockStatus === "success"
                      ? true
                      : false
                  }
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                />
              </Grid>

              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Reason For Slow Movement{" "}
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={4}
                  value={currentslowmovingproducts?.reasonForSlowMovement}
                  name="reasonForSlowMovement"
                  placeholder="Enter reasonForSlowMovement"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "reasonForSlowMovement",
                    })
                  }
                  error={
                    currentslowmovingproducts.reasonForSlowMovementStatus ===
                    "error"
                      ? true
                      : false
                  }
                  success={
                    currentslowmovingproducts.reasonForSlowMovementStatus ===
                    "success"
                      ? true
                      : false
                  }
                />
              </Grid>
            </Grid>
          </MaterialBox>

          {type != "view" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={() => navigate("/slow-moving-products")}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleSubmit}
              >
                {type == "add" ? "Submit" : "update"}
              </MaterialButton>
            </MaterialBox>
          )}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default SlowmovingProductsForm;
